import React, { Component } from 'react';
import { ExpandLlegendaSvg } from './LlegendaFooterIconsElement';

export class ExpandLlegendaIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isButtonHovered: false
    };
  }

  render = () => {
    return (
      <ExpandLlegendaSvg
        innerWidth={window.innerWidth}
        isHover={this.state.isButtonHovered}
        onMouseEnter={() => this.setState({ isButtonHovered: true })}
        onMouseLeave={() => this.setState({ isButtonHovered: false })}
        fontSizeEnabled={this.props.fontSizeEnabled}>
        <path
          className="expand-llegenda"
          d="m100 0h312a100.193 100.193 0 0 1 100 100v312a100.193 100.193 0 0 1 -100 100h-312a100.193 100.193 0 0 1 -100-100v-312a100.193 100.193 0 0 1 100-100zm6 387.251a18.754 18.754 0 0 0 18.75 18.749h98.133a18.751 18.751 0 1 0 0-37.5h-52.865l69.8-69.8a18.752 18.752 0 0 0 -26.518-26.523l-69.8 69.81v-52.87a18.751 18.751 0 0 0 -37.5 0zm300-262.5a18.755 18.755 0 0 0 -18.75-18.751h-98.133a18.751 18.751 0 1 0 0 37.5h52.87l-69.81 69.8a18.753 18.753 0 0 0 26.523 26.523l69.8-69.81v52.871a18.751 18.751 0 0 0 37.5 0z"
        />
      </ExpandLlegendaSvg>
    );
  };
}
